import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22.787,
	height: 19.874,
	viewBox: "0 0 22.787 19.874",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_6282",
		"data-name": "Group 6282",
		transform: "translate(-242 -4260)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Union_36",
			"data-name": "Union 36",
			d: "M15740.832,13592.874a.784.784,0,0,1-.708-.407.736.736,0,0,1,0-.819l10.563-18.24a.819.819,0,0,1,1.416,0l10.563,18.24a.751.751,0,0,1,0,.819.789.789,0,0,1-.708.407Z",
			transform: "translate(-15498 -9313)",
			fill: "#ea3943"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_6281",
			"data-name": "Group 6281",
			transform: "translate(-78.342 -4.399)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "warning_FILL0_wght400_GRAD0_opsz48",
				d: "M23.493,22.368Zm.088-2.968a.854.854,0,0,0-.882.882V25.1a.882.882,0,1,0,1.763,0v-4.82a.854.854,0,0,0-.882-.882Zm0,9.845A.854.854,0,1,0,22.95,29,.856.856,0,0,0,23.582,29.245Z",
				transform: "translate(308.153 4252)",
				fill: "#fff"
			}), /* @__PURE__ */ _jsx("path", {
				id: "warning_FILL0_wght400_GRAD0_opsz48-2",
				"data-name": "warning_FILL0_wght400_GRAD0_opsz48",
				d: "M23.493,22.368Zm.088-2.968a.854.854,0,0,0-.882.882V25.1a.882.882,0,1,0,1.763,0v-4.82a.854.854,0,0,0-.882-.882Zm0,9.845A.854.854,0,1,0,22.95,29,.856.856,0,0,0,23.582,29.245Z",
				transform: "translate(308.153 4252)",
				fill: "#fff"
			})]
		})]
	})
});
export { SvgRedWarning as ReactComponent };
